import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ValidityExtensionListState, ValidityExtensionPayload, Filter } from './models';
import { AppThunk, RootState } from '../..';
import { getValidityList } from 'api/validityExtension';

export const initialValidityExtensionList: ValidityExtensionListState = {
    data: [],
    meta: {
        page: 1,
        pageCount: 1,
        limit: 20,
    },
    filter: {
        pageSize: 20,
        page: 1,
    },
    isLoading: false,
    hasError: false,
}

const validityExtensionSlice = createSlice({
    name: 'validityExtension',
    initialState: initialValidityExtensionList,
    reducers: {
        requestValidityExtension(state) {
            return { ...state, isLoading: true, hasError: false }
        },
        requestedValidityExtensionFailed(state) {
            return { ...state, isLoading: false, hasError: true }
        },
        receivedValidityExtension(state, action: PayloadAction<ValidityExtensionPayload>) {
            const { data, filter, meta } = action.payload
            const newFilter = {
                ...state.filter,
                ...filter,
            }
            return { ...state, data, meta, filter: newFilter, isLoading: false, hasError: false }
        }
    },
});

export const { requestValidityExtension, requestedValidityExtensionFailed, receivedValidityExtension } = validityExtensionSlice.actions;

export const fetchValidityExtension = (filter: Filter): AppThunk => async dispatch => {
    dispatch(requestValidityExtension())
    try {
        const response = await getValidityList(filter)
        if (response) {
            const { results: data, ...meta } = response.data
            dispatch(receivedValidityExtension({ data, filter, meta }))
        }
    } catch (error) {
        dispatch(requestedValidityExtensionFailed())
    }
}

export const selectValidityExtension = (state: RootState) => state.validityExtensionList;
export default validityExtensionSlice.reducer;